export const FLOW_METRIC_COLUMNS = [
  "A/B",
  "C/D",
  "(A+B)/(C+D)",
  "Time of peak exhale/Length of breath",
  "Percent Change",
  "Volume at peak exhale",
  "Volume at peak inhale",
  "Flow at peak exhale",
  "Flow at peak inhale",
];
